// @ts-nocheck
/* eslint-disable */
export const textAdIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M210-290h540v-60H210v60Zm0-160h540v-60H210v60Zm0-160h378v-60H210v60Zm-70 450q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm0 0v-520 520Z"/></svg>`,
    name: 'text-ad' as const
};